import { FunctionComponent } from 'react';
import { useStreetPageQuery } from '../../graphql/useStreetPageQuery';
import { mapApiBadgeVariantToBadgeVariant } from '../../../app-kit/helpers/mapApiBadgeVariantToBadgeVariant';
import { StreetPagePropertyCollectionBrick } from './StreetPagePropertyCollectionBrick';

export const StreetPagePropertyCollectionBricksWithData: FunctionComponent = () => {
  const collections = useStreetPageQuery()?.data?.streetPageBySlug?.propertyCollections ?? [];

  if (!collections.length) return null;
  const propertyCollections = collections.filter((collection) => collection !== null);

  return (
    <>
      {propertyCollections.map(({ title, subtitle, properties, tracking, collectionType }) => {
        if (!properties) return null;
        return (
          <StreetPagePropertyCollectionBrick
            title={title}
            subtitle={subtitle}
            key={title}
            showPropTrackLogo={collectionType === 'SOLD'}
            properties={properties.map(
              ({ path, clickThroughTracking, priceV2, address, imageV2, badge, features }) => ({
                path,
                clickThroughSource: clickThroughTracking,
                title: priceV2,
                subtitle: address,
                image: imageV2,
                badge: {
                  ...badge,
                  variant: mapApiBadgeVariantToBadgeVariant(badge.variant),
                },
                features: features?.map((feature) => ({
                  ...feature,
                  iconName: feature.iconNameV2,
                })),
              }),
            )}
            tracking={tracking}
          />
        );
      })}
    </>
  );
};
